export const platformScreens = {
  mt4: {
    label: 'MT4',
    full: 'MetaTrader 4',
    caption: 'ภาพประกอบหน้าจอ MT4',
    image:
      'https://readdy.ai/api/search-image?query=Minimal%20flat%20illustration%20of%20a%20desktop%20trading%20platform%20window%20on%20a%20light%20mint%20background%2C%20left%20sidebar%20list%20of%20currency%20rows%2C%20one%20main%20chart%20panel%20with%20simple%20teal%20candlesticks%2C%20thin%20warm%20orange%20trend%20lines%2C%20clean%20grid%2C%20soft%20shadows%2C%20no%20text%2C%20no%20people%2C%20no%20logos%2C%20editorial%20fintech%20style&width=1200&height=800&seq=mt4-screen-start-01&orientation=landscape',
  },
  mt5: {
    label: 'MT5',
    full: 'MetaTrader 5',
    caption: 'ภาพประกอบหน้าจอ MT5',
    image:
      'https://readdy.ai/api/search-image?query=Minimal%20flat%20illustration%20of%20a%20modern%20multi%20panel%20trading%20platform%20on%20a%20light%20mint%20background%2C%20several%20small%20chart%20tiles%20with%20teal%20candles%2C%20a%20narrow%20market%20list%20on%20the%20left%2C%20warm%20orange%20accents%2C%20clean%20grid%2C%20no%20text%2C%20no%20people%2C%20no%20logos%2C%20editorial%20fintech%20style&width=1200&height=800&seq=mt5-screen-start-01&orientation=landscape',
  },
};

export const platformChoices = [
  {
    key: 'mt4',
    target: 'mt4-guide',
    name: 'MetaTrader 4',
    short: 'MT4',
    description: 'เรียนรู้การใช้งาน MT4 ตั้งแต่พื้นฐานจนถึงการจัดการกราฟและคำสั่งซื้อขาย',
    tags: ['การใช้งานพื้นฐาน', 'กราฟ', 'อินดิเคเตอร์', 'คำสั่งซื้อขาย'],
    cta: 'ดูคู่มือ MT4',
    image: platformScreens.mt4.image,
    caption: platformScreens.mt4.caption,
    tone: 'primary',
  },
  {
    key: 'mt5',
    target: 'mt5-guide',
    name: 'MetaTrader 5',
    short: 'MT5',
    description: 'ทำความเข้าใจ MT5 พร้อมเรียนรู้เครื่องมือกราฟ อินดิเคเตอร์ และการจัดการคำสั่งซื้อขาย',
    tags: ['การใช้งานพื้นฐาน', 'กราฟ', 'เครื่องมือ', 'คำสั่งซื้อขาย'],
    cta: 'ดูคู่มือ MT5',
    image: platformScreens.mt5.image,
    caption: platformScreens.mt5.caption,
    tone: 'accent',
  },
];

export const comparisonRows = [
  {
    dimension: 'แพลตฟอร์มและการใช้งาน',
    icon: 'ri-computer-line',
    mt4: 'หน้าจอเรียบง่าย น้ำหนักเบา เปิดได้ลื่นแม้บนเครื่องสเปกทั่วไป และมีเมนูไม่เยอะจนมือใหม่สับสน',
    mt5: 'หน้าจอใกล้เคียง MT4 แต่มีแผงเครื่องมือเพิ่มขึ้น ต้องใช้เวลาทำความคุ้นเคยกับเมนูมากกว่าเล็กน้อย',
  },
  {
    dimension: 'เครื่องมือวิเคราะห์กราฟ',
    icon: 'ri-line-chart-line',
    mt4: 'มีกรอบเวลา 9 แบบ และเครื่องมือวาดเส้นพื้นฐานครบสำหรับการวิเคราะห์แนวโน้มและแนวรับแนวต้าน',
    mt5: 'มีกรอบเวลาละเอียดถึง 21 แบบ พร้อมเครื่องมือวาดเพิ่มเติม และมีปฏิทินเศรษฐกิจในแพลตฟอร์ม',
  },
  {
    dimension: 'อินดิเคเตอร์และเครื่องมือเสริม',
    icon: 'ri-pulse-line',
    mt4: 'มีอินดิเคเตอร์ในตัวราว 30 ตัว ซึ่งเพียงพอต่อการเทรด Forex ด้วยวิธีพื้นฐานทั่วไป',
    mt5: 'มีอินดิเคเตอร์ในตัวราว 38 ตัว และรองรับเครื่องมือทดสอบกลยุทธ์ที่ละเอียดกว่า',
  },
  {
    dimension: 'ประเภทคำสั่งซื้อขาย',
    icon: 'ri-exchange-dollar-line',
    mt4: 'มีคำสั่ง Market 2 แบบ และคำสั่ง Pending 4 แบบ รวมเป็น 6 แบบ',
    mt5: 'มีคำสั่ง Market 2 แบบ และคำสั่ง Pending 6 แบบ (เพิ่ม Buy Stop Limit และ Sell Stop Limit) รวมเป็น 8 แบบ',
  },
  {
    dimension: 'การใช้งานสำหรับผู้เริ่มต้น',
    icon: 'ri-user-smile-line',
    mt4: 'คู่มือและคลิปสอนภาษาไทยมีมากกว่า และเพียงพอสำหรับการเทรด Forex ทั่วไป',
    mt5: 'เรียนรู้ได้ไม่ยากหากเข้าใจ MT4 มาก่อน แต่เนื้อหาสอนภาษาไทยยังน้อยกว่า',
  },
];

export const demoTutorials = [
  {
    platform: 'MT4',
    badge: 'เส้นแนวโน้ม',
    title: 'วิธีเพิ่มเส้นแนวโน้มใน MT4',
    description: 'วาดเส้นแนวโน้มจากจุดสูงหรือจุดต่ำสำคัญ แล้วปรับให้เห็นทิศทางราคาได้ชัดขึ้นในไม่กี่คลิก',
    steps: [
      'เลือกเครื่องมือ Trendline จากแถบเครื่องมือหรือเมนู Insert > Objects',
      'คลิกจุดเริ่มต้นแล้วลากไปยังจุดสิ้นสุดของแนวโน้ม',
      'ดับเบิลคลิกที่เส้นเพื่อปรับสีและความหนาให้อ่านง่าย',
    ],
    slug: 'mt4-add-trendline',
    image:
      'https://readdy.ai/api/search-image?query=Minimal%20flat%20illustration%20of%20a%20single%20candlestick%20chart%20window%20on%20a%20light%20mint%20background%20with%20a%20warm%20orange%20diagonal%20trend%20line%20drawn%20from%20a%20low%20point%20to%20a%20higher%20low%2C%20tiny%20tool%20palette%20at%20the%20top%20edge%2C%20teal%20candles%2C%20clean%20grid%2C%20no%20text%2C%20no%20people%2C%20no%20logos%2C%20editorial%20fintech%20style&width=1200&height=800&seq=demo-mt4-trendline-01&orientation=landscape',
    caption: 'ภาพประกอบขั้นตอนวาดเส้นแนวโน้ม',
  },
  {
    platform: 'MT5',
    badge: 'ข้อความบนกราฟ',
    title: 'วิธีเพิ่มข้อความลงในกราฟ MT5',
    description: 'จดเหตุผลการเข้าและระดับราคาสำคัญไว้บนกราฟ เพื่อไม่ต้องเดาซ้ำทุกครั้งที่กลับมาดู',
    steps: [
      'ไปที่ Insert > Text หรือกดปุ่มตัวอักษร A บนแถบเครื่องมือ',
      'คลิกตำแหน่งที่ต้องการ แล้วพิมพ์ข้อความสั้น ๆ ลงไป',
      'ดับเบิลคลิกข้อความเพื่อแก้ไข หรือลากย้ายตำแหน่งได้ตลอดเวลา',
    ],
    slug: 'mt5-add-text',
    image:
      'https://readdy.ai/api/search-image?query=Minimal%20flat%20illustration%20of%20a%20candlestick%20chart%20window%20on%20a%20light%20mint%20background%20with%20a%20small%20warm%20orange%20note%20label%20pinned%20beside%20a%20price%20level%2C%20teal%20candles%2C%20floating%20text%20tool%20icon%2C%20clean%20grid%2C%20no%20readable%20text%2C%20no%20people%2C%20no%20logos%2C%20editorial%20fintech%20style&width=1200&height=800&seq=demo-mt5-text-01&orientation=landscape',
    caption: 'ภาพประกอบขั้นตอนเพิ่มข้อความ',
  },
];

export const platformFaqs = [
  {
    q: 'MT4 และ MT5 แตกต่างกันอย่างไร',
    a: 'ความต่างหลักอยู่ที่จำนวนกรอบเวลา จำนวนอินดิเคเตอร์ ประเภทคำสั่งซื้อขาย และสินทรัพย์ที่รองรับ โดย MT5 มีกรอบเวลาละเอียดกว่า มีคำสั่ง Pending มากกว่า และรองรับสินทรัพย์หลากหลายกว่า ส่วนหลักการดูกราฟและเปิดออเดอร์เหมือนกัน',
    a2: 'ถ้านับเป็นตัวเลข MT4 มีกรอบเวลา 9 แบบ อินดิเคเตอร์ในตัวราว 30 ตัว และคำสั่งรวม 6 แบบ ขณะที่ MT5 มี 21 แบบ 38 ตัว และ 8 แบบตามลำดับ MT5 ยังมีปฏิทินเศรษฐกิจและเครื่องมือทดสอบกลยุทธ์อยู่ในตัว ซึ่งมีประโยชน์หากต้องการทดสอบระบบก่อนใช้เงินจริง แต่ถ้าเป้าหมายคือเทรด Forex ด้วยวิธีพื้นฐาน MT4 ก็ยังเพียงพอและเบากว่า',
  },
  {
    q: 'ควรเริ่มเรียนรู้ MT4 หรือ MT5 ก่อน',
    a: 'เริ่มจากแพลตฟอร์มที่โบรกเกอร์ของคุณรองรับเต็มรูปแบบจะง่ายที่สุด หากโบรกเกอร์ให้ MT4 มา ให้เริ่มที่ MT4 ก่อนเพราะคู่มือภาษาไทยมีมากกว่า และหลักการที่ได้ใช้ต่อกับ MT5 ได้ทันที',
    a2: 'ถ้าโบรกเกอร์รองรับทั้งสองแพลตฟอร์มพร้อมกัน ให้เลือก MT4 ก่อนเพราะเมนูน้อยกว่าและหาคู่มือภาษาไทยได้ง่าย จากนั้นใช้เวลาราว 1-2 สัปดาห์ทำความคุ้นเคยกับหน้าจอ แล้วค่อยย้ายไป MT5 คำสั่งและวิธีตั้ง Stop Loss / Take Profit เหมือนกัน จึงไม่ต้องเริ่มเรียนรู้ใหม่ทั้งหมด',
  },
  {
    q: 'วิธีเปลี่ยนกรอบเวลาในกราฟทำอย่างไร',
    a: 'ทั้งสองแพลตฟอร์มเปลี่ยนกรอบเวลาได้จากปุ่มบนแถบเครื่องมือ หรือเมนู Charts > Timeframe โดย MT4 มี 9 กรอบเวลา และ MT5 มี 21 กรอบเวลา',
    a2: 'ความต่างที่เห็นชัดคือ MT5 เพิ่มกรอบอย่าง M2 M3 M10 และ M20 ข้ามมา ซึ่งมีประโยชน์เมื่อต้องการดูการเคลื่อนไหวสั้น ๆ ที่กรอบ 1 นาทีหรือ 5 นาทีจับไม่ทัน ถ้าดูกราฟ H1 แล้วอยากเห็นภาพรวมใหญ่ขึ้น ให้กดปุ่ม timeframe ด้านบนกราฟเลือก H4 หรือ D1 ได้ทันทีโดยไม่ต้องเปิดหน้าต่างใหม่',
  },
  {
    q: 'ทำไมกราฟจึงไม่แสดงราคา',
    a: 'สาเหตุที่พบบ่อยคือการเชื่อมต่อหลุดหรือยังไม่ได้ล็อกอินเข้าเซิร์ฟเวอร์ ให้ตรวจสถานะมุมขวาล่างแล้วล็อกอินใหม่ หากเชื่อมต่อปกติแต่กราฟว่าง ให้ตรวจว่าสินทรัพย์นั้นยังเปิดให้เทรดอยู่ในขณะนั้น',
    a2: 'อีกสองจุดที่ควรเช็กคือ Market Watch มีคู่เงินนั้นแสดงอยู่หรือไม่ และเซิร์ฟเวอร์ที่ล็อกอินตรงกับบัญชีหรือเปล่า เพราะบางครั้งการล็อกอินค้างไว้จากรอบก่อนทำให้เห็นกราฟว่างโดยไม่แจ้งเตือน นอกจากนี้กราฟที่เปิดค้างไว้ช่วงสุดสัปดาห์จะกลับมาแสดงอีกครั้งเมื่อตลาดเปิดในวันจันทร์',
  },
  {
    q: 'วิธีเพิ่มอินดิเคเตอร์ทำอย่างไร',
    a: 'เพิ่มได้จากเมนู Insert > Indicators หรือลากอินดิเคเตอร์จาก Navigator ลงบนกราฟ หลังจากนั้นปรับค่าได้ด้วยการดับเบิลคลิกที่เส้นหรือกด Ctrl+I แล้วเลือก Edit',
    a2: 'ไม่ควรใส่เกิน 2-3 ตัวต่อกราฟ เพราะอินดิเคเตอร์ที่วัดเรื่องเดียวกันหลายตัวจะให้สัญญาณขัดกันเองจนตัดสินใจไม่ได้ ถ้าเพิ่งเริ่มต้น ลอง Moving Average 1 ตัวคู่กับ RSI 1 ตัวก็เพียงพอ แล้วจดบันทึกว่าค่าที่ตั้งไว้ให้ผลอย่างไรก่อนปรับรอบถัดไป',
  },
  {
    q: 'วิธีตั้ง Stop Loss และ Take Profit ทำอย่างไร',
    a: 'กรอกทั้งสองช่องในหน้าต่าง New Order ก่อนกดยืนยันคำสั่ง โดยใส่เป็นระดับราคา ไม่ใช่จำนวนเงิน และต้องห่างจากราคาปัจจุบันเกินระยะขั้นต่ำที่ระบบกำหนด',
    a2: 'จุดที่มือใหม่พลาดบ่อยคือกำหนด Stop Loss เป็นจำนวนเงินที่ยอมเสีย แล้วไม่คำนวณกลับเป็นระยะ Pip ทำให้ Lot ใหญ่เกินจริง สูตรที่ใช้ได้คือ เงินที่ยอมเสีย หารด้วย (ระยะ Stop Loss เป็น Pip คูณมูลค่าต่อ Pip) เช่น ยอมเสีย 20 ดอลลาร์ ระยะ 40 Pip บน EUR/USD จะได้ 0.05 lot',
  },
  {
    q: 'บัญชีทดลอง (Demo) กับบัญชีจริงต่างกันอย่างไร ควรเริ่มจากแบบไหน',
    a: 'บัญชีทดลองใช้เงินสมมติ เปิดออเดอร์ได้เหมือนบัญชีจริงแต่ไม่มีความเสี่ยงเรื่องเงิน จึงควรใช้ฝึกทุกขั้นตอนก่อน โดยเฉพาะการตั้ง Stop Loss และการปิดออเดอร์ แต่ต้องเข้าใจว่าคำสั่งในบัญชีทดลองอาจไม่ได้ถูกส่งเข้าตลาดจริง และราคาที่ได้จึงไม่ใช่ราคาที่คุณจะได้รับจริงทั้งหมด อีกทั้งบัญชีทดลองของบางโบรกเกอร์จะหมดอายุหากไม่มีการเข้าใช้งานนานหลายสัปดาห์ เมื่อหมดอายุให้เปิดบัญชีทดลองใหม่ได้เลย',
  },
  {
    q: 'ทำไมเวลาใน MT4 และ MT5 ไม่ตรงกับเวลาไทย',
    a: 'เพราะแพลตฟอร์มไม่ได้ใช้เวลาไทย แต่ใช้เวลาเซิร์ฟเวอร์ของโบรกเกอร์ซึ่งมักเป็น GMT+2 หรือ GMT+3 ขณะที่ประเทศไทยอยู่ที่ GMT+7 เวลาของแท่งเทียนจึงเริ่มและจบไม่ตรงกับนาฬิกาที่คุณใช้อยู่ ทางที่ดีคือดูเวลาที่มุมล่างของหน้าจอแพลตฟอร์มเป็นหลัก แล้วคำนวณส่วนต่างกับเวลาไทยครั้งเดียว จากนั้นจดไว้ใช้ตลอด เพราะเวลาเซิร์ฟเวอร์อาจเปลี่ยนตามช่วงปรับเวลาของต่างประเทศ',
  },
  {
    q: 'Lot คืออะไร และ Margin กับ Free Margin ต่างกันอย่างไร',
    a: 'Lot คือขนาดสัญญาของออเดอร์ ไม่ใช่จำนวนเงินที่คุณจะเสียหากขาดทุน เช่น 1.00 lot ของ EURUSD มีขนาด 100,000 หน่วย จึงทำให้กำไรหรือขาดทุนต่อการเคลื่อนที่ของราคา 1 pip มากกว่าการเทรด 0.01 lot ถึงหนึ่งร้อยเท่า ส่วน Margin คือเงินที่ถูกกันไว้เป็นหลักประกันขณะที่ออเดอร์ยังเปิดอยู่ และ Free Margin คือเงินที่ยังเหลือและสามารถใช้เปิดออเดอร์เพิ่มได้ หาก Free Margin ใกล้ศูนย์ โบรกเกอร์อาจบังคับปิดออเดอร์เพื่อจำกัดความเสียหาย',
  },
  {
    q: 'หาไม่เจอคู่เงินที่ต้องการใน Market Watch ต้องทำอย่างไร',
    a: 'หน้าต่าง Market Watch ตั้งแต่เปิดโปรแกรมครั้งแรกจะแสดงเพียงไม่กี่คู่เงิน ให้คลิกขวาในหน้าต่างนั้นแล้วเลือก Show All เพื่อแสดงคู่เงินทั้งหมดที่มี หรือเลือก Symbols เพื่อค้นหาชื่อคู่เงินที่ต้องการแล้วกด Show หากยังหาไม่เจอ ให้สังเกตว่าบางโบรกเกอร์เติมตัวอักษรต่อท้ายชื่อคู่เงิน เช่น EURUSD.a หรือ EURUSDm ซึ่งเป็นบัญชีประเภทเดียวกัน และควรตรวจว่าโบรกเกอร์นั้นเปิดให้เทรดคู่เงินนี้อยู่หรือไม่',
  },
  {
    q: 'ติดตั้ง MT4 และ MT5 บนมือถือได้ไหม ใช้บัญชีเดิมได้หรือไม่',
    a: 'ได้ทั้งสองแพลตฟอร์ม ให้ค้นหาแอปชื่อ MetaTrader 4 หรือ MetaTrader 5 ใน App Store หรือ Google Play แล้วติดตั้งจากผู้พัฒนา MetaQuotes เท่านั้น จากนั้นล็อกอินด้วยเลขบัญชี รหัสผ่าน และชื่อเซิร์ฟเวอร์ชุดเดียวกับที่ใช้บนคอมพิวเตอร์ ข้อมูลออเดอร์จะตรงกันโดยอัตโนมัติ อย่างไรก็ตามหน้าจอมือถือเล็กกว่ามาก จึงเหมาะสำหรับติดตามสถานะและปิดออเดอร์มากกว่าการวิเคราะห์กราฟหรือตั้งค่าอินดิเคเตอร์ละเอียด',
  },
  {
    q: 'ดาวน์โหลด MT4 และ MT5 จากที่ไหนถึงปลอดภัย',
    a: 'ดาวน์โหลดจากเว็บไซต์ของโบรกเกอร์ที่คุณเปิดบัญชี หรือเว็บไซต์ทางการของ MetaQuotes เท่านั้น หลีกเลี่ยงเว็บไซต์รับดาวน์โหลดทั่วไปที่มักพ่วงโปรแกรมอื่นมาด้วย ด้านความปลอดภัยของบัญชี ไม่ควรให้รหัสผ่านแก่ผู้ใดที่อ้างว่าช่วยเทรดให้ และระวังไฟล์ EA หรืออินดิเคเตอร์ที่ขอข้อมูลล็อกอิน เพราะสิ่งที่ควรได้รับคือไฟล์ .ex4 หรือ .ex5 ที่นำไปติดตั้งเองในแพลตฟอร์ม ไม่ใช่การส่งรหัสผ่านไปให้ผู้อื่น',
  },
];

export const beginnerEssentials = [
  {
    icon: 'ri-user-shared-line',
    tone: 'secondary',
    title: 'บัญชีทดลองกับบัญชีจริงต่างกันอย่างไร',
    points: [
      'บัญชีทดลองใช้เงินสมมติ ฝึกได้เต็มที่โดยไม่เสี่ยงเงินจริง',
      'ราคาใกล้เคียงบัญชีจริง แต่คำสั่งอาจไม่ได้ส่งเข้าตลาดจริง',
      'บัญชีทดลองบางแห่งหมดอายุหากไม่ใช้งานนาน ต้องเปิดใหม่',
    ],
  },
  {
    icon: 'ri-time-line',
    tone: 'accent',
    title: 'เวลาแพลตฟอร์มไม่ตรงกับเวลาไทย',
    points: [
      'แพลตฟอร์มมักใช้เวลาเซิร์ฟเวอร์ GMT+2 หรือ GMT+3 ไม่ใช่ GMT+7',
      'แท่งเทียนจึงเริ่มและจบไม่ตรงกับนาฬิกาที่คุณใช้อยู่',
      'ให้ยึดเวลาที่มุมล่างของหน้าจอแพลตฟอร์มเป็นหลัก',
    ],
  },
  {
    icon: 'ri-scales-3-line',
    tone: 'primary',
    title: 'Lot, Margin และ Free Margin คืออะไร',
    points: [
      'Lot คือขนาดสัญญาของออเดอร์ ไม่ใช่จำนวนเงินที่คุณจะเสีย',
      'Margin คือเงินที่ถูกกันไว้เป็นหลักประกันตอนเปิดออเดอร์',
      'Free Margin คือเงินที่ยังเหลือไว้เปิดออเดอร์เพิ่มได้',
    ],
  },
  {
    icon: 'ri-search-line',
    tone: 'accent',
    title: 'หาคู่เงินที่ต้องการไม่เจอ',
    points: [
      'Market Watch แสดงเพียงไม่กี่คู่ตั้งแต่เปิดโปรแกรมครั้งแรก',
      'คลิกขวาในหน้าต่างนั้นแล้วเลือก Show All เพื่อแสดงทั้งหมด',
      'บางโบรกเกอร์มีตัวอักษรต่อท้ายชื่อคู่เงิน เช่น EURUSD.a',
    ],
  },
  {
    icon: 'ri-smartphone-line',
    tone: 'primary',
    title: 'MT4 และ MT5 บนมือถือ',
    points: [
      'ดาวน์โหลดแอปชื่อ MetaTrader 4 หรือ MetaTrader 5 จาก App Store หรือ Google Play',
      'ใช้เลขบัญชีและเซิร์ฟเวอร์ชุดเดียวกับที่ล็อกอินบนคอมได้',
      'หน้าจอเล็กกว่า จึงเหมาะดูสถานะมากกว่าวิเคราะห์และตั้งค่า',
    ],
  },
  {
    icon: 'ri-shield-check-line',
    tone: 'secondary',
    title: 'ความปลอดภัยของบัญชีและการดาวน์โหลด',
    points: [
      'ดาวน์โหลดจากเว็บไซต์โบรกเกอร์หรือเว็บทางการของ MetaQuotes เท่านั้น',
      'ไม่แชร์รหัสผ่านให้ผู้อื่น รวมถึงคนที่อ้างว่าช่วยเทรดให้',
      'ระวังไฟล์ EA หรืออินดิเคเตอร์ที่ขอรหัสผ่านบัญชีของคุณ',
    ],
  },
];

export const nextLearningSteps = [
  {
    title: 'Forex พื้นฐาน',
    description: 'ทำความเข้าใจคู่เงิน Pip Spread Leverage และ Margin ก่อนลงลึกกับแพลตฟอร์ม',
    path: '/forex-basics',
    icon: 'ri-book-open-line',
    meta: '30 บทความพื้นฐาน',
  },
  {
    title: 'วิธีเทรด Forex',
    description: 'วางแผนเทรด เลือกประเภทคำสั่ง และเปิดออเดอร์ตามขั้นตอนอย่างเป็นระบบ',
    path: '/forex-trading',
    icon: 'ri-line-chart-line',
    meta: 'ขั้นตอนเทรดครบวงจร',
  },
  {
    title: 'การบริหารความเสี่ยง',
    description: 'กำหนดความเสี่ยงต่อออเดอร์และขนาดสถานะให้พอดีกับพอร์ตที่คุณมี',
    path: '/risk-management',
    icon: 'ri-shield-check-line',
    meta: 'ป้องกันพอร์ตก่อนขาดทุนหนัก',
  },
];

export const learningRoadmap = {
  mt4: [
    {
      step: '01',
      title: 'ติดตั้งและเข้าสู่ระบบ',
      summary: 'เริ่มจากให้โปรแกรมเปิดใช้งานได้จริงก่อน แล้วค่อยไปดูส่วนอื่น',
      points: [
        'ดาวน์โหลดตัวติดตั้งจากเว็บไซต์โบรกเกอร์ที่คุณใช้งาน',
        'ติดตั้งเสร็จแล้วเปิดบัญชีทดลองเพื่อฝึกโดยไม่ใช้เงินจริง',
        'ล็อกอินด้วยเลขบัญชี รหัสผ่าน และชื่อเซิร์ฟเวอร์ที่ได้รับ',
      ],
    },
    {
      step: '02',
      title: 'ทำความรู้จักหน้าจอและกราฟ',
      summary: 'รู้ว่าข้อมูลคู่เงินอยู่ตรงไหน และปรับกราฟให้อ่านง่าย',
      points: [
        'ทำความคุ้นเคยกับหน้าต่าง Market Watch และ Navigator',
        'เปิดกราฟคู่เงินที่ต้องการ แล้วเลือกกรอบเวลาจาก 9 แบบ',
        'ฝึกซูม เลื่อนกราฟ และเปลี่ยนรูปแบบแท่งเทียน',
      ],
    },
    {
      step: '03',
      title: 'เพิ่มอินดิเคเตอร์และเครื่องมือวาด',
      summary: 'เริ่มจากอินดิเคเตอร์พื้นฐานไม่กี่ตัว ไม่ต้องใส่ให้เต็มจอ',
      points: [
        'เพิ่มอินดิเคเตอร์จากเมนู Insert > Indicators',
        'ปรับค่าพารามิเตอร์ให้เหมาะกับคู่เงินที่กำลังดู',
        'วาดเส้นแนวโน้มและแนวรับแนวต้านด้วยเครื่องมือบนแถบด้านบน',
      ],
    },
    {
      step: '04',
      title: 'เปิดคำสั่งซื้อขายและจัดการความเสี่ยง',
      summary: 'ขั้นสุดท้ายคือเปิดออเดอร์ให้เป็น และปิดให้เป็นระบบ',
      points: [
        'ฝึกเปิดออเดอร์ด้วยคำสั่ง Market บนบัญชีทดลอง',
        'ตั้ง Stop Loss และ Take Profit ก่อนกดยืนยันทุกครั้ง',
        'ตรวจประวัติการซื้อขายเพื่อทบทวนผลลัพธ์ของตัวเอง',
      ],
    },
  ],
  mt5: [
    {
      step: '01',
      title: 'ติดตั้งและเข้าสู่ระบบ',
      summary: 'ตรวจเวอร์ชันให้ตรงกับที่โบรกเกอร์รองรับ แล้วเข้าสู่ระบบให้ครบ',
      points: [
        'เลือกเวอร์ชัน MT5 จากหน้าเว็บไซต์โบรกเกอร์ของคุณ',
        'ติดตั้งแล้วเปิดบัญชีทดลองสำหรับฝึกใช้งาน',
        'กรอกเลขบัญชี รหัสผ่าน และเซิร์ฟเวอร์ให้ตรงกับที่โบรกเกอร์แจ้ง',
      ],
    },
    {
      step: '02',
      title: 'ทำความรู้จักหน้าจอและกราฟ',
      summary: 'MT5 มีแผงเครื่องมือมากกว่า เลยควรรู้ว่าอะไรอยู่ตรงไหนก่อน',
      points: [
        'ทำความคุ้นเคยกับ Market Watch, Navigator และ Toolbox',
        'เลือกกรอบเวลาจาก 21 แบบที่มีให้ใช้',
        'ทดลองเปิดกราฟหลายหน้าต่างพร้อมกันเพื่อเทียบกัน',
      ],
    },
    {
      step: '03',
      title: 'เพิ่มอินดิเคเตอร์และเครื่องมือ',
      summary: 'ใช้คลังอินดิเคเตอร์ในตัวและเครื่องมือวิเคราะห์เพิ่มเติม',
      points: [
        'ค้นหาอินดิเคเตอร์จากคลังในตัวที่มีให้เลือกกว่าสามสิบตัว',
        'ทดลองเครื่องมือวิเคราะห์เพิ่มเติมและปฏิทินเศรษฐกิจในแพลตฟอร์ม',
        'บันทึกเทมเพลตกราฟไว้ใช้ซ้ำในครั้งต่อไป',
      ],
    },
    {
      step: '04',
      title: 'เปิดคำสั่งซื้อขายและจัดการความเสี่ยง',
      summary: 'ฝึกทั้งคำสั่ง Market และคำสั่ง Pending ที่ MT5 มีมากกว่า',
      points: [
        'ฝึกเปิดและปิดสถานะด้วยคำสั่ง Market',
        'ทดลองคำสั่ง Pending แบบ Buy Stop Limit และ Sell Stop Limit',
        'ตรวจประวัติการซื้อขายในแท็บ History ของ Toolbox',
      ],
    },
  ],
};